import { AdminVisitorsIndex } from '@/components/admin/visitors/AdminVisitorsIndex';
import { useAuthenticated } from '@gettactic/hooks';

export const Visitors = () => {
  const {
    userContext: { currentOffice }
  } = useAuthenticated();

  return (
    <div className="flex items-center justify-center h-full max-w-full">
      <AdminVisitorsIndex
        isRedesign={true}
        officeId={currentOffice?.id}
      />
    </div>
  );
};
